// Simple example of a React "smart" component

import { connect } from 'react-redux';
import FanUpcomingEvents from '../components/FanUpcomingEvents';
import * as actions from '../actions/fanUpcomingEventsActionCreators';

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state) => ({
  csrfToken: state.csrfToken,
  team: state.team,
  currentUser: state.currentUser,
  confirms: state.confirms,
  itemsCountPerPage: state.itemsCountPerPage,
  activePage: state.activePage
});

const mapDispatchToProps = (dispatch) => {
  return {
    activePageChanged: (activePage) => dispatch(actions.activePageChanged(activePage))
  }
};

// Don't forget to actually use connect!
// Note that we don't export HelloWorld, but the redux "connected" version of it.
// See https://github.com/reactjs/react-redux/blob/master/docs/api.md#examples
export default connect(mapStateToProps, mapDispatchToProps)(FanUpcomingEvents);
